// 説明
// redux + redux-watch + is-equalを使っていると
// 一つのアクションに含まれる全てのデータについて、
// 前のデータと新しいデータの比較を行ってしまう。
// 多くの場合、前のデータに一部新しいデータをマージする形になるので、
// 更新されていないデータは前と同じ。
// にも関わらず、全て比較するため大きなパフォーマンスの低下を招いていた。
// このユーティリティーはそれを防ぐためのものだが、
// Appクラスに最新のpayloadのデータを入れる義務をreducersに強いており、
// App, reducers　に強い依存関係を持ってしまっている。
// 本来であればreduxのミドルウェアとして実装すべき案件かもしれないが、
// 取り急ぎこれで場を凌ぐ。

import isEqual from 'is-equal';
import watch from "redux-watch";
import objectPath from 'object-path';
let objectPath = require('object-path')
let getValue = objectPath.get;
let hasValue = objectPath.has;

export function watchRedux(getState, objectPath, compare = isEqual) {
  // compare = compare || defaultCompare
  var currentValue = getValue(getState(), objectPath)
  return function w (fn) {
    return function () {
      if(!hasValue(App.currentPayload, objectPath)){
        return true;
      }
      var newValue = getValue(getState(), objectPath)
      if (!compare(currentValue, newValue)) {
        var oldValue = currentValue
        currentValue = newValue
        fn(newValue, oldValue, objectPath)
      }
    }
  }
}
